import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { a as u } from "../../../index-CROKJrb5.js";
import { c as m, f } from "../../../create-component-CBAeEoQ6.js";
const x = m(
  "CardFooter",
  f(
    ({ as: r, children: o, className: t, ...a }, c) => {
      const e = r || "div";
      return /* @__PURE__ */ s.jsx(
        e,
        {
          ref: c,
          className: u(
            "cur-order-last cur-flex cur-w-full cur-shrink-0 cur-flex-wrap cur-gap-2 [&>*]:cur-w-0 [&>*]:cur-grow",
            t
          ),
          ...a,
          children: o
        }
      );
    }
  )
);
export {
  x as CardFooter
};
//# sourceMappingURL=index.js.map
